import Particles from 'react-tsparticles';

function BackgroundTile() {
    return (
        <div className='absolute -z-50'>
            <Particles
                id='tsparticles'
                style={{}}
                options={{
                    fullScreen: {
                        enable: true,
                    },
                    fpsLimit: 60,
                    particles: {
                        groups: {
                            z5000: {
                                number: {
                                    value: 70,
                                },
                                zIndex: {
                                    value: 5000,
                                },
                            },
                            z7500: {
                                number: {
                                    value: 30,
                                },
                                zIndex: {
                                    value: 75,
                                },
                            },
                            z2500: {
                                number: {
                                    value: 50,
                                },
                                zIndex: {
                                    value: 25,
                                },
                            },
                            z1000: {
                                number: {
                                    value: 40,
                                },
                                zIndex: {
                                    value: 10,
                                },
                            },
                        },
                        number: {
                            value: 175,
                            // density: {
                            //     enable: false,
                            //     value_area: 800,
                            // },
                        },
                        color: {
                            value: '#fff',
                            animation: {
                                enable: false,
                                speed: 20,
                                sync: true,
                            },
                        },
                        shape: {
                            type: 'circle',
                        },
                        opacity: {
                            value: 1,
                            random: false,
                            animation: {
                                enable: false,
                                speed: 3,
                                minimumValue: 0.1,
                                sync: false,
                            },
                        },
                        size: {
                            value: 3,
                        },
                        links: {
                            enable: false,
                            distance: 100,
                            color: '#ffffff',
                            opacity: 0.4,
                            width: 1,
                        },
                        move: {
                            angle: {
                                value: 10,
                                offset: 0,
                            },
                            enable: true,
                            trail:{
                                enable:true,
                                length:2,
                                // fillColor:
                            },
                            speed: 1,
                            direction: 'right',
                            random: true,
                            straight: false,
                            outModes: {
                                default: 'out',
                            },
                            attract: {
                                enable: false,
                                rotateX: 600,
                                rotateY: 1200,
                            },
                        },
                        zIndex: {
                            value: 5,
                            opacityRate: 0.5,
                        },
                    },
                    detectRetina: true,
                    background: {
                        color: '#000000',
                        image: '',
                        position: '50% 50%',
                        repeat: 'no-repeat',
                        size: 'cover',
                    },
                }}
            />
        </div>
    );
}

export default BackgroundTile;
